import React from 'react';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { useT } from '../../salesI18n';
import { InchesInput } from './InchesInput';
import { COMPONENT_TYPE_IDS, BOW_COUNTS, defaultComponents } from './openingShapes';

// Janelas internas de Bay (3) / Bow (4–8): tipo + largura × altura de cada uma
export const InnerWindowsFields = ({ type, value = [], onChange }) => {
  const { t } = useT();
  const setCount = (n) => onChange([...value.slice(0, n), ...defaultComponents(type, Math.max(0, n - value.length)).map((c, i) => ({ ...c, type: type === 'BAY' ? (value.length + i === 1 ? 'PW' : 'DH') : 'CS' }))]);
  const setRow = (i, k, v) => onChange(value.map((c, j) => (j === i ? { ...c, [k]: v } : c)));
  return (
    <div className="rounded-2xl border border-teal-100 bg-teal-50/40 p-3 space-y-2" data-testid="opening-inner-windows">
      <div className="flex items-center justify-between gap-2">
        <div>
          <p className="text-sm font-semibold text-slate-900">{t.innerWindows}</p>
          <p className="text-[11px] text-slate-500">{t.innerWindowsHint}</p>
        </div>
        {type === 'BOW' && (
          <Select value={String(value.length)} onValueChange={(v) => setCount(Number(v))}>
            <SelectTrigger className="h-9 w-20 text-xs font-mono shrink-0" data-testid="opening-inner-count"><SelectValue /></SelectTrigger>
            <SelectContent>{BOW_COUNTS.map((n) => <SelectItem key={n} value={String(n)} data-testid={`opening-inner-count-${n}`}>{n}</SelectItem>)}</SelectContent>
          </Select>
        )}
      </div>
      <div className="space-y-1.5">
        {value.map((c, i) => (
          <div key={i} className="grid grid-cols-[28px_1fr_1fr_1fr] gap-1.5 items-end" data-testid={`opening-inner-row-${i}`}>
            <span className="h-11 w-7 rounded-lg bg-white border border-teal-200 text-teal-800 font-mono text-xs font-bold flex items-center justify-center" aria-label={t.innerN(i + 1)}>{i + 1}</span>
            <div>
              {i === 0 && <Label className="text-[10px] text-slate-500">{t.openingType}</Label>}
              <Select value={c.type} onValueChange={(v) => setRow(i, 'type', v)}>
                <SelectTrigger className="h-11 text-xs bg-white" data-testid={`opening-inner-type-${i}`}><SelectValue /></SelectTrigger>
                <SelectContent>{COMPONENT_TYPE_IDS.map((x) => <SelectItem key={x} value={x} data-testid={`opening-inner-type-${i}-${x}`}>{t.componentTypes[x]}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div>{i === 0 && <Label className="text-[10px] text-slate-500">{t.measureShort.width}</Label>}<InchesInput testId={`opening-inner-width-${i}`} value={c.width ?? ''} onChange={(v) => setRow(i, 'width', v)} /></div>
            <div>{i === 0 && <Label className="text-[10px] text-slate-500">{t.measureShort.height}</Label>}<InchesInput testId={`opening-inner-height-${i}`} value={c.height ?? ''} onChange={(v) => setRow(i, 'height', v)} /></div>
          </div>
        ))}
      </div>
    </div>
  );
};
